import { Injectable } from '@angular/core';
import { initializeApp, FirebaseApp } from 'firebase/app';
import { FIREBASE_CONFIG } from 'src/environments/environment';
import { getToken, isSupported, getMessaging, Messaging } from 'firebase/messaging';
import { isPlatform } from '@ionic/angular';
import { Auth, getAuth, indexedDBLocalPersistence, initializeAuth, setPersistence } from 'firebase/auth';
import { Database } from 'firebase/database';


@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

  private app: FirebaseApp;
  private messaging: Messaging
  public auth: Auth
  database: Database;

  constructor() {

  }

  initializeFirebase() {
    this.app = initializeApp(FIREBASE_CONFIG);
    if (isPlatform('hybrid')) {
      this.auth = initializeAuth(this.app, { persistence: indexedDBLocalPersistence })
    } else {
      this.auth = getAuth(this.app);
      setPersistence(this.auth, indexedDBLocalPersistence)
    }

    isSupported().then(() => {
      // this.messaging = getMessaging();

      // Add the public key generated from the console here.
      // getToken(this.messaging, { vapidKey: this.messaging['vapidKey'] }).then((token) => {
      //   console.log(token)
      // });


      // this.messaging = getMessaging(this.app)
      // getToken(this.messaging).then((token) => {
      //   console.log(token)
      // })
      // console.log('lol')
    })

  }
  getDatabaseInstance(): Database {
    return this.database;
  }
}
